import { createSpotlight } from '@mantine/spotlight';

export const [locationSpotlightStore, locationSpotlight] = createSpotlight();

export function openLocationSpotlight() {
  locationSpotlightStore.setState((state) => ({ ...state, query: '' }));
  locationSpotlight.open();
}
